module.exports = "<h3 class=\"topless\">Your Account</h3>\n\n<p>\n  <strong>Name:</strong>\n  {{user.first_name}} {{user.last_name}}\n</p>\n\n<p>\n  <strong>Email:</strong>\n  {{user.email}}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /srv/src/app/settings/settings.component.html
// module id = ../../../../../src/app/settings/settings.component.html
// module chunks = main